import ResourceComponent from '../../../common/ResourceComponent';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import * as actions from '../EmbeddableApi';
import {connect} from 'react-redux';
import {Col, Row} from 'reactstrap';
import React from 'react';
import SortDropdown from './SortDropdown';
import {getBackgroundColor, reverseColor} from '../../../common/Utils';
import {formatPhoneNumber} from 'react-phone-number-input';

class DesktopMenu extends ResourceComponent {
    render() {
        const {
            settings, items, filters, setAvailableInventory, loading,
            getItemRange, changeSort, clientInformation,
        } = this.props;
        const {customerLogoUrl, phoneNumber, website} = clientInformation;
        const backgroundColor = getBackgroundColor(settings.left_container_color);
        const color = reverseColor(backgroundColor);

        const sticky_header_styles = {
            padding: '10px',
            position: 'fixed',
            flexWrap: 'inherit',
            marginLeft: 0,
            top: 0, left: 0,
            gap: '10px',
            backgroundColor,
        };

        const standard_header_styles = {
            padding: '10px',
            gap: '10px',
            backgroundColor,
        };
        return (
            <Row className='w-100 m-0 d-xl-flex header-container desktop-container align-items-center flex-wrap'
                 style={settings.sticky_header ? sticky_header_styles : standard_header_styles}>
                {settings.show_logo_and_contact && <Row className='w-100'>
                    <Col sm={3}>
                        <div className={`logo-content ${settings.sticky_header ? 'ml-3' : ''}`}>
                            <div>
                                {website ? (
                                    <a
                                        target='_blank'
                                        rel='noreferrer'
                                        href={`https://${website}`}>
                                        <img style={{height: '50px'}} src={customerLogoUrl ? customerLogoUrl : ''} />
                                    </a>
                                ) : <img style={{height: '50px'}} src={customerLogoUrl ? customerLogoUrl : ''} />}

                            </div>
                        </div>
                    </Col>
                    {phoneNumber && <Col sm={9} className='pr-0 d-flex justify-content-end align-content-center'>
                        <Row className='d-flex align-content-center' style={{marginRight: '-5px'}}>
                            <span>Contact Us: {formatPhoneNumber(phoneNumber)}</span>
                        </Row>
                    </Col>}
                </Row>}
                <Row className='w-100 m-0 d-xl-flex align-items-center'>
                    <Col sm={4} className={`${settings.sticky_header ? '' : 'p-0'}`}>
                        <span style={{color}} className='h6'>Available inventory: </span>
                        <span style={{color}} className='h5'><b>{setAvailableInventory()}</b></span>
                    </Col>
                    <Col sm={8} className='pr-0'>
                        <div className='d-flex float-right align-items-center'>
                            <div className='float-right mr-3'>
                        <span style={{color}} className='ml-1'>
                            <b>{getItemRange()}</b> of {items.total_entries || 0} results
                        </span>
                            </div>
                            <SortDropdown filters={filters} changeSort={changeSort} loading={loading} />
                        </div>
                    </Col>
                </Row>
            </Row>
        );
    }
}

DesktopMenu.contextTypes = {
    router: PropTypes.object,
};

DesktopMenu.propTypes = {
    actions: PropTypes.object,
    history: PropTypes.object,
};

const mapStateToProps = ({appState}) => ({
    profile: appState.profile,
    claimedItems: appState.claimedItems,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        actions,
        dispatch),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DesktopMenu);


// WEBPACK FOOTER //
// ./src/containers/embeddable/utils/DesktopMenu.js